import React, { Component } from 'react'
import {
    MDBContainer,
    MDBBtn,
    MDBModal,
    MDBModalBody,
    MDBModalHeader,
    MDBModalFooter
} from 'mdbreact';
import { MDBRow, MDBCol, MDBIcon } from "mdbreact";
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip , Divider } from 'antd';
import { api } from '../../api';
import Swal from 'sweetalert2'

export default class Modaladdfileprocurement extends Component {

    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            loading: false,
            namework: '',
            fileupload: '',

            name_workorder: '',
            worklistdata: [],
           
            filedesing_workorder: '',

            typeducument:'',

        }

        this.handleSubmit = this.handleSubmit.bind(this);
        this.toggle = this.toggle.bind(this);
        this.handleChangefile = this.handleChangefile.bind(this);
        this.onTextChange = this.onTextChange.bind(this);
        this.updateSearchDepartment = this.updateSearchDepartment.bind(this);
       
    }
    onTextChange = (e) => {
        this.setState({ [e.target.name]: e.target.value })
    }

    handleChangefile(event) {    this.setState({fileupload: event.target.files[0]});  }

    toggle = () => {
        this.setState({
            modal: !this.state.modal
        });
    }


    updateSearchDepartment(event) {
        // console.log(event.target.value)
        const typeducument = event.target.value;
        this.setState({ typeducument });
 
    //     setTimeout(() => {
    //      this.getthcouncil()
    //    }, 500);
      }

    handleSubmit(e) {
        e.preventDefault();
        // alert('A name was submitted: ' + this.state.value);
        const date = new Date().toISOString().slice(0, 10)
        const id_member = localStorage.getItem('id_member') 

        
       setTimeout(() => {
    
          const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
          datafrm.append("procurement_name", this.state.namework);
          datafrm.append("news_file", this.state.fileupload);
          datafrm.append("procurement_datesent", date);
          datafrm.append("procurement_status", 1);
          datafrm.append("procurement_group", this.state.typeducument);
          datafrm.append("news_id_member", id_member);
          //datafrm.append("id_workorder", this.state.id_workorder);
        
          api.post("updatefileprocurement.php",datafrm,{
                headers: {
                    'content-type': 'multipart/form-data'
                }
            })
    
       .then(res => {
        if (res.status=== 200) {
            Swal.fire({
                title: 'บันทึกรายการสำเร็จ',
                icon: 'success',
              // showCancelButton: true,
                confirmButtonText: 'ตกลง',
              // cancelButtonText: 'No, keep it'
              }).then((result) => {
                this.toggle();  
            //  this.getworklist();
               // this.props.getnews();
               this.props.getprocurement();
               this.props.getita();
              })
        }else{
          message.error("อัพโหลไฟล์ไม่สำเร็จ!")
        }
    
      })
    
    
    }, 2000);
    
    //window.location.href = '/adminfaculty'
    //this.props.updateat();
    //this.getExpert()
     
      }

    render() {
    console.log(this.state.typeducument)
 //   console.log(this.state.fileupload)
        return (
            <MDBContainer>
                <MDBBtn color="pink" onClick={this.toggle}>เพิ่มข้อมูล</MDBBtn>
                <MDBModal isOpen={this.state.modal} toggle={this.toggle}>
                    <MDBModalHeader toggle={this.toggle}>เพิ่มข้อมูลจัดซื้อจัดจ้าง/ITA</MDBModalHeader>
                    <MDBModalBody>
                        <form onSubmit={this.handleSubmit}>

                            <div>
                            <label className="font-weight-bold"><MDBIcon icon="bible" />เลือกประเภทเอกสาร</label>
                                 <select className="browser-default custom-select" style={{ width: '100%' }}   onChange={this.updateSearchDepartment}   icon="user" >
                                        <option>-- เลือกประเภทเอกสาร --</option>
                                        <option value="1">เอกสารจัดซื้อจัดจ้าง</option>
                                        <option value="2">เอกสาร ITA</option>
                                </select>  
                            </div>
                            <br/>

                            <div className="mb-2">
                                <label className="font-weight-bold"><MDBIcon icon="bible" /> ชื่อรายการ</label>
                                <input className="form-control" onChange={this.onTextChange} name="namework"
                                    value={this.state.namework} placeholder="" required />
                            </div>
                            <br />
                            <MDBRow>
                                <MDBCol md="12">
                                    <div className="mb-2">
                                        <label className="font-weight-bold"><MDBIcon icon="paperclip" /> ไฟล์อัพโหลด .PDF</label><br />
                                        {/* <MDBInput   group   type="file" validate error="wrong"
                                    success="right"  name="file" value={this.state.value} onChange={this.handleChange}/> */}

                                        {/* <input className="custom-file-input" type="file" onChange={this.handleChangefile} name="auth_agency" 
                                      value={this.state.auth_agency} placeholder="" required /> */}
                                        {/* <MDBInput  icon="file-upload" group   type="file" validate error="wrong"
                                        success="right"  name="file" accept="image/x-png,image/jpg,image/jpeg" value={this.state.value} onChange={this.handleChange} required/> */}
                                        <input type="file" id="img" name="fileupload" onChange={this.handleChangefile} accept="application/pdf" ></input>
                                    </div>
                                </MDBCol>

                            </MDBRow>
                            {/* <Divider orientation="left" plain>
                            Left Text
                            </Divider> */}
                            {/* {this.state.filedesing_workorder == '' && this.state.filedesing_workorder == null ? <></> : <>
                                <MDBRow>
                                    <MDBCol>
                                        <img src={`https://lookmaenamping.com/sorlalumbackend/uploadsdesing/${this.state.filedesing_workorder}`} className="rounded mx-auto d-block " width="500" alt="aligment" />
                                    </MDBCol>
                                </MDBRow>
                            </>} */}


                            {/* <p className="purple-text text-center">ตรวจสอบข้อมูลว่าถูกต้องครบถ้วน</p> */}
                            <div className="mt-3 text-center" >
                                <MDBBtn type="submit" color="deep-purple" className="text-center"> <MDBIcon far icon="save" /> บันทึก</MDBBtn>
                                <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn>
                            </div>


                        </form>
                    </MDBModalBody>
                    <MDBModalFooter>
                        {/* <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn> */}
                        {/* <MDBBtn color="primary">Save changes</MDBBtn> */}
                    </MDBModalFooter>
                </MDBModal>
            </MDBContainer>
        )
    }
}
